import { Module } from "wrapper6";

var $ = jQuery;

export default class Print extends Module {

	ready(app) {

		$(document).on('click', '.print', function(e){

			window.print();

			e.preventDefault();

		});

    }
}